import axios from 'axios';

// 1. Definisci la baseURL leggendo la variabile d'ambiente.
// Se la variabile non c'è (caso raro se hai configurato i file .env), usa il localhost come fallback.
const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost/unitestai/api';

// 2. Crea l'istanza di axios
const api = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// INTERCEPTOR: Prima di ogni richiesta, aggiungi il token
api.interceptors.request.use(
    (config) => {
        // Recupera il token
        const userSession = JSON.parse(localStorage.getItem('user_session')); 
        const token = userSession?.token; 

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;